import React, { useEffect, useContext, useState, useCallback, useRef } from 'react';

import PresentPC from 'components/pages/OrderType/PresentPC';
import PresentSP from 'components/pages/OrderType/PresentSP';

import { 
  useWindowDimensions,
  isSchemaValid,
  useDirectTransCheck,
  useIECheck,
  sortErrors,
  isCustomValid,
  postHeightToParent,
} from 'utils';

import {
  CHOICES_MAP,
} from 'utils/constant';

import AppContext from 'fluxes/context';
import { UPDATE_TYPE, CHANGE_VALID } from 'fluxes/actions';

const OrderType = () => {
  const path = window.location.pathname;
  const { state, dispatch } = useContext(AppContext);
  useDirectTransCheck({ state });

  const [ physicalCare, setPhysicalCare ] = useState(state.physicalCare);
  const [ lifeSupport, setLifeSupport ] = useState(state.lifeSupport);
  const [ otherWorkText, setOtherWorkText ] = useState(state.otherWorkText);
  const [ PCisAllCheck, setPCIsAllCheck ] = useState(false);
  const [ LSisAllCheck, setLSIsAllCheck ] = useState(false);
  
  const { width } = useWindowDimensions();
  const isIE = useIECheck();
  const isSp = width <= 640 && !isIE;
  const pageEl = useRef(null);

  // 入力チェック
  const initialValid = { valid: state.validMap[path], errorMessages: [] };
  const [ valids, setValids ] = useState({
    schema: initialValid,
    checkOrderType: initialValid,
  });
  const [ isShowError, setIsShowError ] = useState({
    otherWorkText: false,
  });
  const valid = Object.keys(valids).every(key => valids[key].valid);
  const dispErrors = useCallback(() => {
    const { schema, checkOrderType } = valids;
    const errors = sortErrors([
      ...schema.errorMessages,
      ...checkOrderType.errorMessages,
    ]);
    const errorMap = errors.reduce((obj, error) => {
      const { target, message } = error;
      if(!isShowError[target] || Object.keys(obj).includes(target)) return obj;
      return { ...obj, [target]: message };
    }, {});
    console.log({ errorMap });
    return errorMap;
  }, [ isShowError, valids ]);

  // 入力チェック
  useEffect(()=> {
    const validation = () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = isSchemaValid({
        target: {
          physicalCare,
          lifeSupport,
          otherWorkText,
        },
      });
      console.log('valid:schema', { isValid, newErrorMessages });
     
      // erros更新
      const newValid = { schema: { valid: isValid, errorMessages: newErrorMessages } };
      setValids(org => ({ ...org, ...newValid }));
    };

    validation();

  }, [ physicalCare, lifeSupport, otherWorkText, isShowError ]);

  // 入力チェック
  useEffect(()=> {
    const validation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkOrderType' ],
        target: {
          physicalCare,
          lifeSupport,
          otherWorkText,
        },
      });
      console.log('valid:custom', { isValid, newErrorMessages });
      
      // erros更新
      const newValid = { checkOrderType: { valid: isValid, errorMessages: newErrorMessages } };
      setValids(org => ({ ...org, ...newValid }));
    };

    validation();

  }, [ physicalCare, lifeSupport, otherWorkText, isShowError ]);
  
  // LP埋め込み時の高さ送信
  useEffect(() => {
    if(state.lpMode){
      postHeightToParent(state.lpOrigin, pageEl.current.clientHeight);
    }
  }, [ state.lpMode, state.lpOrigin, pageEl ]);

  // onChangeイベント群
  const handleChangePhysicalCare = e => {
    const val = e.target.value;
    if (physicalCare.includes(val)) {
      setPhysicalCare(physicalCare.filter(item => item !== val));
    } else {
      setPhysicalCare([ ...physicalCare, val ]);
    }
  };

  const handleChangeLifeSupport = e => {
    const val = e.target.value;
    if (lifeSupport.includes(val)) {
      setLifeSupport(lifeSupport.filter(item => item !== val));
    } else {
      setLifeSupport([ ...lifeSupport, val ]);
    }
  };

  const handleChangeOtherWorkText = e => {
    const val = e.target.value;
    setOtherWorkText(val);
      
    // otherWorkTextエラー表示開始
    if(!isShowError.otherWorkText) {
      setIsShowError({ ...isShowError, otherWorkText: true });
    }
  };

  /* すべてにチェックのonChangeイベント群 */
  const physicalCareIsAllCheck = ()=>{
    setPCIsAllCheck(!PCisAllCheck);
    if(!PCisAllCheck){
      setPhysicalCare([ '01', '02', '03', '04', '05' ]);
    }else{
      setPhysicalCare([]);
    }
  };
  const lifeSupportIsAllCheck = ()=>{
    setLSIsAllCheck(!LSisAllCheck);
    if(!LSisAllCheck){
      setLifeSupport([ '01', '02', '03', '04', '05' ]);
    }else{
      setLifeSupport([]);
    }
  };
  
  // 全てチェックがついたら、すべてのチェックボックスをtrueにする
  useEffect (()=>{
    if(physicalCare.length === 5){
      setPCIsAllCheck(true);
    }else{
      setPCIsAllCheck(false);
    }
  }, [ physicalCare ]);
  
  useEffect (()=>{
    if(lifeSupport.length === 5){
      setLSIsAllCheck(true);
    }else{
      setLSIsAllCheck(false);
    }
  }, [ lifeSupport ]);

  // 画面項目の作成
  // 表示する文言,各state,各onChange
  const { TypeTitleList } = CHOICES_MAP;
  const textList = [ '身体介護', '生活援助' ];
  const typeStateList = [ physicalCare, lifeSupport ];
  const stateOnChangeList = [ handleChangePhysicalCare, handleChangeLifeSupport ];
  const checkStateList = [ PCisAllCheck, LSisAllCheck ];
  const allCheckOnChangeList = [ physicalCareIsAllCheck, lifeSupportIsAllCheck ];
  const typeList = TypeTitleList.map((title, idx) =>
    ({ title, text: textList[idx], typeState: typeStateList[idx], stateOnChange: stateOnChangeList[idx],
      checkState: checkStateList[idx], allCheckOnChange: allCheckOnChangeList[idx] }));


  // ボタン押下
  // state更新処理

  const updateState = () => {
    dispatch({ 
      type: UPDATE_TYPE,
      updType: {
        physicalCare,
        lifeSupport,
        otherWorkText,
      },
    });
  };
  const onClickMainButton = {
    prev: () => {
      updateState();
    },
    next: () => {
      updateState();
      dispatch({
        type: CHANGE_VALID, 
        path,
        valid,
      });
    },
  };

  return(
    <div id='pageType' ref={pageEl}>
      { isSp ? (
        <PresentSP 
          onClickMainButton={onClickMainButton}
          valid={valid}
          errorDispMap={dispErrors()}
          typeList={typeList}
          // その他業務
          otherWorkText={otherWorkText}
          handleChangeOtherWorkText={handleChangeOtherWorkText}
          lpMode={state.lpMode}
        />
      ) : (
        <PresentPC 
          onClickMainButton={onClickMainButton}
          valid={valid}
          errorDispMap={dispErrors()}
          typeList={typeList}
          // その他業務
          otherWorkText={otherWorkText}
          handleChangeOtherWorkText={handleChangeOtherWorkText}
          lpMode={state.lpMode}
        />
      )}
    </div>
  );
};

export default OrderType;